import { AfterViewInit, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgxSmartModalComponent, NgxSmartModalService } from 'ngx-smart-modal';
import { NgxSpinnerService } from 'ngx-spinner';
import * as Prism from 'prismjs';

import { AbstractListComponent } from '../../../../model/AbstractListComponent';
import { SharedService } from '../../../../shared/shared.service';
import {
  ListStudentePrenotazioneLaboratorioDTO,
  StudentePrenotazioneLaboratorioDTO,
} from './../../../../model/newModel';
import { ListPrenotazioniService } from './list-prenotazioni.service';

@Component({
  selector: 'app-list-prenotazioni',
  templateUrl: './list-prenotazioni.component.html',
  styleUrls: ['./list-prenotazioni.component.css'],
})
export class ListPrenotazioniComponent
  extends AbstractListComponent
  implements AfterViewInit, OnInit {
  options = {
    format: 'DD/MM/YYYY, HH:mm',
  };
  listPrenotazioni: ListStudentePrenotazioneLaboratorioDTO;
  dataSelected: Date;
  tempListPrenotazioni: StudentePrenotazioneLaboratorioDTO[];

  currentDate = new Date();

  showPrenotazioni: boolean;

  ngOnInit(): void {
    super.ngOnInit();
    this.getListPrenotazioni();
  }

  getListPrenotazioni() {
    this.spinner.show();
    this.listPrenotazioniService.search(this.student.id).subscribe(
      (result) => {
        this.listPrenotazioni = result;
        this.calcolaListVaiA(this.listPrenotazioni.pages);
        this.idVaiA = '' + (this.listPrenotazioni.currentPage - 1);
        if (this.listPrenotazioni.studentiPrenotazioniLaboratorio.length > 0) {
          this.showPrenotazioni = true;
        } else {
          this.showPrenotazioni = false;
        }
        this.tempListPrenotazioni = Object.assign(
          [],
          this.listPrenotazioni.studentiPrenotazioniLaboratorio
        );
        this.spinner.hide();
      },
      (error) => {
        this.spinner.hide();
        console.log('Errore search');
      }
    );
  }

  elimina(id: number, dataInizio: Date) {
    const currentDataInizio = new Date(dataInizio);
    if (this.currentDate.getTime() >= currentDataInizio.getTime()) {
      const text =
        'Non puoi cancellare prenotazioni precedenti o che scadono oggi';
      this.sharedService.openWarningModal(text);
    } else {
      this.spinner.show();
      this.listPrenotazioniService.delete(id).subscribe(
        (result) => {
          this.spinner.hide();
          this.sharedService.openOkModal();
          this.modalSubscribe = this.ngxSmartModalService
            .getModal('okModal')
            .onClose.subscribe((modal: NgxSmartModalComponent) => {
              window.location.reload();
            });
        },
        (error) => {
          this.spinner.hide();
          console.log('Errore delete');
        }
      );
    }
  }

  /**
   * @method ngAfterViewInit
   */
  ngAfterViewInit() {
    Prism.highlightAll();
  }

  constructor(
    public ngxSmartModalService: NgxSmartModalService,
    public router: Router,
    private sharedService: SharedService,
    private spinner: NgxSpinnerService,
    private listPrenotazioniService: ListPrenotazioniService
  ) {
    super();
  }

  nextPage(skip: number, take: number, count: number) {
    this.spinner.show();
    this.listPrenotazioniService
      .nextPage(this.student.id, skip, take, count)
      .subscribe(
        (result) => {
          this.listPrenotazioni = result;
          this.calcolaListVaiA(this.listPrenotazioni.pages);
          this.idVaiA = '' + (this.listPrenotazioni.currentPage - 1);
          this.spinner.hide();
        },
        (error) => {
          console.log('Errore search next');
          this.spinner.hide();
        }
      );
  }

  goToPage(idVaiA: string, event: any) {
    this.spinner.show();
    this.listPrenotazioniService
      .goToPage(this.student.id, idVaiA, this.listPrenotazioni.take)
      .subscribe(
        (result) => {
          this.listPrenotazioni = result;
          this.calcolaListVaiA(this.listPrenotazioni.pages);
          this.idVaiA = '' + (this.listPrenotazioni.currentPage - 1);
          this.spinner.hide();
        },
        (error) => {
          console.log('Errore search goToPage');
          this.spinner.hide();
        }
      );
  }

  previousPage(skip: number, take: number) {
    this.spinner.show();
    this.listPrenotazioniService
      .previousPage(this.student.id, skip, take)
      .subscribe(
        (result) => {
          this.listPrenotazioni = result;
          this.calcolaListVaiA(this.listPrenotazioni.pages);
          this.idVaiA = '' + (this.listPrenotazioni.currentPage - 1);
          this.spinner.hide();
        },
        (error) => {
          console.log('Errore search previous');
          this.spinner.hide();
        }
      );
  }
}
